import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import SliderRecentMoviesContainer from "./containers/sliderrecentmoviescontainer.component";
import LastNewsContainer from "../lastnews/containers/lastnewscontainer.component";
import Filters from "../../../SHARED/components/filters/filters.component";
import MovieResultsContainerRecentMovies from "./containers/movieresultscontainer.component";
import RecommendedForYou from "../recommendedforyou/recommendedforyou.component";
import Ads from "../ads/ads.component";
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
import { Helmet } from 'react-helmet';

class RecentMovies extends Component {

    componentWillMount(){
        window.scrollTo(0, 0);
    }

    componentDidMount(){
        pageViewEvent('Filme recent apărute. Filme noi - Cinemap','/filme-recente');
    }

    render() {
        return (
            <div className="recent-movies">
                <Helmet>
                    <title>Filme recent apărute. Filme noi - Cinemap</title>
                    <meta name="description" content="Vizualizează lista cu filmele recent apărute în cinematografe."/>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                {window.innerWidth > 1000 ? 
                    <Ads
                        id="div-gpt-ad-1662463178982-0"
                        slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); googletag.pubads().refresh();});"
                    /> : 
                    <Ads
                        id="div-gpt-ad-1662463706379-0"
                        slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
                    />
                }
                {this.props.loading !==0 ? <Spinner /> : ''}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9">
                            <SliderRecentMoviesContainer />
                        </div>
                        <div className="col-lg-3">
                            <LastNewsContainer />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 order-2 order-sm-2 order-md-1 sidebar-filters">
                            <Filters component="recentMovies"/>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-9 order-1 order-sm-1 order-md-2">
                            <MovieResultsContainerRecentMovies />
                        </div>
                    </div>
                    <div className="row">
                        <div className="section-headline">
                            ARTICOLE RECOMANDATE PENTRU TINE
                        </div>
                        <RecommendedForYou/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests
});
export default connect(mapStateToProps, {})(RecentMovies);



// WEBPACK FOOTER //
// ./src/FO/components/recentmovies/recentmovies.component.js